import React, { useEffect, useRef, useState } from "react";
import Header from "./header/Header";
import { DialogConfirm, DialogShow } from "components/app/dialog";
import appStore from "store/appStore";
import { DialogUploadPostContent } from "components/app/dialog/dialog-upload-post-content/DialogUploadPostContent";
import ViewPostModal from "pages/view-post/ViewPostModal";
import AlertWellcome from "pages/auth/alert/AlertWellcome";
import ViewStoryModal from "pages/view-story/ViewStoryModal";
import DailogCreateYourShop from "./header/dialog/DailogCreateYourShop";
import { Outlet } from "react-router-dom";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import { DialogUploadEditPostContent } from "components/app/dialog/dialog-upload-edit-post-content/DialogUploadEditPostContent";
import Header2 from "./header/Header2";
import { Service } from "utils/services";
import { AppLog } from "services";
import { useDispatch } from "react-redux";
import { setAccountProfile, setLoadingAccountProfile } from "store/layoutSlice";

export default function Layout({
  isHideLayout = false,
  isHeader2 = false,
  headerType,
}: {
  isHideLayout?: boolean;
  isHeader2?: boolean;
  headerType?: "businessSuite" | "profileSuite";
}) {
  const dispatch = useDispatch();
  const getHeaderType: any = headerType;
  const hasFetchedAccountProfile = useRef<boolean>(false);

  const {
    // Dialog Message
    dialogMessage,
    hideDialogMessage,

    // Dialog Confirm
    dialogConfirm,
    hideDialogConfirm,

    // Dialog Upload
    dialogUploadPostContent,
    hideDialogUploadPostContent,

    // Dialog Upload Edit
    dialogUploadEditPostContent,
    hideDialogUploadEditPostContent,

    // Dialog Post View Modal
    dialogPostModal,
    onCloseDialogPostModal,

    // Dialog Welcome login
    dialogWelcome,
    onCloseDialogWelcome,

    // Dialog Story
    dialogViewStoryModal,
    onCloseDialogViewStoryModal,
  } = appStore();

  const [showAlert, setShowAlert] = useState<boolean>(false);

  const fetchGetAccountProfile = async (isRefresh: boolean) => {
    if (isRefresh) {
      try {
        dispatch(setLoadingAccountProfile(true));
        let url: string = "";
        url = RouteApi.getAccountProfile;
        url += `token=${Service.token}`;

        const response = await RequestApi(url);
        if (response.status === "success") {
          hasFetchedAccountProfile.current = true;
          dispatch(setAccountProfile(response.user_shop));
        } else {
          AppLog.show({ message: response.msg, status: StatusMsg.getType(response.status) });
        }
      } catch (error) {
        AppLog.show({
          message: `[fetchGetAccountProfile]`,
          status: StatusMsg.error,
          error,
        });
      } finally {
        dispatch(setLoadingAccountProfile(false));
      }
    }
  };

  useEffect(() => {
    if (!hasFetchedAccountProfile.current && headerType === "profileSuite") fetchGetAccountProfile(true);
  }, []);

  return (
    <div>
      {!isHideLayout && (isHeader2 ? <Header2 headerType={getHeaderType} /> : <Header />)}
      <div className={`${!isHideLayout && "pt-[80px]"}`}>
        <Outlet />
      </div>
      {/* <Footer /> */}
      {dialogMessage.isOpen && <DialogShow dialogMessageProps={dialogMessage} setIsDialogOpen={() => hideDialogMessage()} />}

      {dialogConfirm.isOpen && <DialogConfirm dialogConfirmProps={dialogConfirm} setIsDialogOpen={hideDialogConfirm} />}

      {dialogUploadPostContent.isOpen && (
        <DialogUploadPostContent
          dialogUploadPostContent={dialogUploadPostContent}
          setIsDialogOpen={() => {
            hideDialogUploadPostContent();
          }}
        />
      )}

      {dialogUploadEditPostContent.isOpen && (
        <DialogUploadEditPostContent dialogUploadEditPostContent={dialogUploadEditPostContent} setIsDialogOpen={() => hideDialogUploadEditPostContent()} />
      )}

      <AlertWellcome showAlert={showAlert} setShowAlert={setShowAlert} />

      {dialogPostModal.isOpen && <ViewPostModal isOpen={dialogPostModal.isOpen} postId={dialogPostModal.postId} onClose={onCloseDialogPostModal} />}

      {dialogWelcome.isOpen && <AlertWellcome showAlert={dialogWelcome.isOpen} setShowAlert={onCloseDialogWelcome} />}

      {dialogViewStoryModal.isOpen && <ViewStoryModal isOpen={dialogViewStoryModal.isOpen} userId={dialogViewStoryModal.userId} onClose={onCloseDialogViewStoryModal} />}

      <DailogCreateYourShop />
    </div>
  );
}
